import {
  AccessTokenResponse,
  ErrorMessageResponse,
  NotificationCounts,
  NotificationItem,
  ResponseListType,
  ResponseType,
} from '@/types';
import {
  useSentryInfiniteQuery,
  useSentryMutation,
  useSentryQuery,
} from '../utils/sentryQueryWrapper';
import {
  fetchNotificationsCount,
  fetchNotificationPreferences,
  fetchNotificationsList,
  NotificationPreferences,
  seenNotification,
  updateNotificationPreferences,
} from '@/api/notificationService';

// Fetch List Notification
export const useFetchNotificationList = (enabled: boolean, notificationType?: string) => {
  return useSentryInfiniteQuery<ResponseListType<NotificationItem>, Error>(
    ['notification-list', notificationType],
    ({ pageParam = 1 }) => fetchNotificationsList(pageParam, notificationType),
    {
      enabled,
      getNextPageParam: (lastPage, allPages) => {
        const { page, pages } = lastPage.object;
        return page < pages ? page + 1 : undefined;
      },
    },
  );
};

//Seen Notification
export const useSeenNotification = () => {
  return useSentryMutation<void, ErrorMessageResponse, string[]>((notificationIds: string[]) =>
    seenNotification(notificationIds),
  );
};

//Fetch Notification Count
export const useFetchNotificationsCount = (enabled: boolean = true) => {
  return useSentryQuery<ResponseType<NotificationCounts>, Error>(
    ['notification-count'],
    () => fetchNotificationsCount(),
    { enabled },
  );
};

// Fetch Notification Preferences
export const useFetchNotificationPreferences = () => {
  return useSentryQuery<ResponseType<NotificationPreferences>, Error>(
    ['notification-preferences'],
    fetchNotificationPreferences,
  );
};

// Update Notification Preferences
export const useUpdateNotificationPreferences = () => {
  return useSentryMutation<ResponseType<NotificationPreferences>, ErrorMessageResponse, Partial<NotificationPreferences>>(
    (data) => updateNotificationPreferences(data),
  );
};
